import type { SVGProps } from 'react';
const DawnFlagGN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-GN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-GN_svg__a)">
      <path fill="#1DBE5E" d="M10.477 0h11.524v16H10.477z" />
      <path fill="#E72B42" fillRule="evenodd" d="M0 16h7.333V0H0z" clipRule="evenodd" />
      <path
        fill="#FFD952"
        fillRule="evenodd"
        d="M7.333 16h7.333V0H7.333z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagGN;
